import bankEstado from '../../banksPNG/bankEstado.png';

interface IconProps {
	width?: string;
	height?: string;
	alt?: string;
}

export const BancoEstadoIcon = ({
	width = '17px',
	height = '17px',
	alt = 'Banco Estado',
}: IconProps) => <img src={bankEstado} width={width} height={height} alt={alt} />;
